module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"a":"Créer le dossier","b":"Sauvegarde automatique en pause.","c":"Sauvegarde en cours...","d":"Sauvegardé."},"en":{"a":"Create CV","b":"Auto-save is paused.","c":"Saving...","d":"Saved."}}')
  delete Component.options._Ctor
}
